import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getSession, clearSession } from "@/lib/api";

// Protected pages call this once at the top. If there's no session, it
// redirects to /login immediately rather than rendering anything that
// would need one.
export function useRequireAuth() {
  const [session] = useState(() => getSession());
  const navigate = useNavigate();

  useEffect(() => {
    if (!session?.session_token) {
      navigate("/login", { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const logout = () => {
    clearSession();
    navigate("/login", { replace: true });
  };

  return { session, logout };
}
